import PaneInitFailureContent from './PaneInitFailureContent';

export default PaneInitFailureContent;
export { PaneInitFailureContent };
